import { Injectable, computed, inject } from '@angular/core';
import { catchError, distinctUntilChanged, map, of, switchMap } from 'rxjs';
import { toSignal, toObservable } from '@angular/core/rxjs-interop';
import { IVoiceIVRData } from '@dxp/core/models';
import { VoiceApiService } from '@dxp/core/api';
import { VoiceService } from './voice.service';

@Injectable({ providedIn: 'root' })
export class VoiceIVRService {
    readonly #voiceService = inject(VoiceService);
    readonly #voiceApiService = inject(VoiceApiService);

    readonly #validCallId = computed(() => {
        const workItem = this.#voiceService.workItem();
        const callId = this.#voiceService.conversation()?.voiceCallId;
        return workItem && !workItem.isOutbound && callId ? +callId : null;
    });

    readonly ivrs = toSignal<IVoiceIVRData[]>(
        toObservable(this.#validCallId).pipe(
            distinctUntilChanged(),
            switchMap(callId =>
                callId == null
                    ? of([])
                    : this.#voiceApiService.getIVRs(callId).pipe(
                          map(res => res?.data ?? []),
                          catchError(_ => of([])),
                      ),
            ),
        ),
    );
}
